<form *ngIf="form" [formGroup]="form" (submit)="save()" [ngClass]="{'invalid-submit': invalidSubmit}">
  <div class="Loyalty ui-g-12 ui-md-12 ui-lg-12">
    <div class="ui-g">
      <div class="ui-g-9 ui-md-9 ui-lg-9">
        <h1 class="step-title">{{fields.title}}</h1>
      </div>
      <div class="ui-g-3 ui-md-3 ui-lg-3 form-button-row">
        <button pButton class="k-generic-btn" type="button" icon="fa fa-arrow-left" iconPos="left" routerLink="/loyalty/selfscanservice" label="{{ 'common.back' | translate }}"></button>
        <button pButton class="k-generic-btn" (click)="save()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}"></button>
      </div>
    </div>
    <div class="card">
      <div class="ui-g ui-fluid">

      <div class="ui-g-12 ui-md-3">
        <span class="label" [ngClass]="{'required': !validationSelfScan.customer_id.nullable}">{{ validationSelfScan.customer_id.keyName }}</span>
        <input type="number" min="0" disabled pInputText class="fieldInput" formControlName="customer_id"/>
      </div>
      <div class="ui-g-12 ui-md-3">
        <span class="label" [ngClass]="{'required': !validationSelfScan.customer_description.nullable}">{{ fields.customer_description }}</span>
        <input type="text"  disabled pInputText class="fieldInput" formControlName="customer_description"/>
      </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label" [ngClass]="{'required': !validationSelfScan.channel_id.nullable}">{{ validationSelfScan.channel_id.keyName }}</span>
          <p-dropdown [disabled]="true" [options]="listChannel" formControlName="channel_id"></p-dropdown>
        </div>
    </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-3">
          <span class="label" >{{ fields.message_id }}</span>
          <input type="number" disabled min="0" pInputText class="fieldInput" formControlName="message_id"/>
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label" >{{ fields.uid_chk_chance }}</span>
          <input type="text" pInputText class="fieldInput" formControlName="uid_chk_chance"/>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="validationSelfScan.uid_chk_chance"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label" >{{ fields.number_trx_checked }}</span>
          <input type="number" min="0" disabled pInputText class="fieldInput" formControlName="number_trx_checked"/>
        </div>
      </div>

      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-3">
          <span class="label" >{{ fields.number_trx_used }}</span>
          <input type="number" min="0" disabled pInputText class="fieldInput" formControlName="number_trx_used"/>
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label" >{{ fields.number_last_check }}</span>
          <input type="number" min="0" disabled pInputText class="fieldInput" formControlName="number_last_check"/>
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label" >{{ fields.date_last_trx }}</span>
          <p-calendar [disabled]="true" formControlName="date_last_trx" dateFormat="dd/mm/yy"></p-calendar>
        </div>
      </div>
      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-3" >
          <span class="label" >{{ fields.number_next_check }}</span>
          <input type="number" min="0" disabled pInputText class="fieldInput" formControlName="number_next_check"/>
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label" >{{ fields.uid_last_check_chance }}</span>
          <input type="text" disabled pInputText class="fieldInput" formControlName="uid_last_check_chance"/>
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label" >{{ fields.last_chk_status }}</span>
          <input type="text" disabled pInputText class="fieldInput" formControlName="last_chk_status"/>
        </div>
      </div>
      <div class="ui-g ui-fluid">
        <div class="ui-g-10 ui-md-3">
          <span class="label">{{ fields.flg_blk_ss }}</span>
          <p-inputSwitch [disabled]="true" formControlName="flg_blk_ss"></p-inputSwitch>
        </div>
      </div>
      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-3">
          <span class="label" [ngClass]="{'required': !validationSelfScan.reason_id.nullable}">{{ validationSelfScan.reason_id.keyName }}</span>
          <p-dropdown [disabled]="true" [options]="listReasons" formControlName="reason_id"></p-dropdown>
        </div>
        <div class="ui-g-12 ui-md-3" >
          <span class="label" >{{ fields.not_payed_trx }}</span>
          <input type="number" min="0" disabled pInputText class="fieldInput" formControlName="not_payed_trx"/>
        </div>
        <div class="ui-g-12 ui-md-3" >
          <span class="label" >{{ fields.trx_tot_time }}</span>
          <input type="number" min="0" disabled pInputText class="fieldInput" formControlName="trx_tot_time"/>
        </div>
      </div>
      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-3" >
          <span class="label" >{{ fields.num_forced_rescan }}</span>
          <input type="number" min="0" disabled pInputText class="fieldInput" formControlName="num_forced_rescan"/>
        </div>
        <div class="ui-g-12 ui-md-3" >
          <span class="label" >{{ fields.num_up_rescan }}</span>
          <input type="number" min="0" disabled pInputText class="fieldInput" formControlName="num_up_rescan"/>
        </div>
        <div class="ui-g-12 ui-md-3" >
          <span class="label" >{{ fields.num_down_rescan }}</span>
          <input type="number" min="0" disabled pInputText class="fieldInput" formControlName="num_down_rescan"/>
        </div>
      </div>
      <div class="ui-g ui-fluid">
        <div class="ui-g-12 ui-md-3" >
          <span class="label" >{{ fields.num_eq_rescan }}</span>
          <input type="number" min="0" disabled pInputText class="fieldInput" formControlName="num_eq_rescan"/>
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label" >{{ fields.last_chk_chance }}</span>
          <input type="text" disabled pInputText class="fieldInput" formControlName="last_chk_chance"/>
        </div>
        <div class="ui-g-12 ui-md-3">
          <span class="label" >{{ fields.curr_chk_chance }}</span>
          <input type="text" disabled pInputText class="fieldInput" formControlName="curr_chk_chance"/>
        </div>
      </div>

    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-self-scan-service/form-self-scan-service/form-self-scan-service.component.html